var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { propArrayShape, propBool, propFunc, propId, propStr, } from '../../../../helpers/custom-prop-types';
import { useBoolState } from '../../../../helpers/use/useHook';
import ContentTagForm from './ContentTagForm';
const ContentTags = (props) => {
    const { canUpdateTag, categoryTags, changeFalseKeyControl, changeTrueKeyControl, id, imageTags, onSubmit: rawOnSubmit, slideId, tags, } = props;
    const { boolState: editMode, changeFalse: changeEditModeFalse, changeTrue: changeEditModeTrue, } = useBoolState(false, changeFalseKeyControl, changeTrueKeyControl);
    const linkTags = useMemo(() => tags.map((tag) => (Object.assign(Object.assign({}, tag), { link: `/proffit_search/search?slideTypes=${tag.id}` }))), [tags]);
    const onSubmit = useCallback((...args) => __awaiter(void 0, void 0, void 0, function* () {
        yield rawOnSubmit(...args);
        changeEditModeFalse();
    }), [rawOnSubmit, changeEditModeFalse]);
    const initialValues = useMemo(() => {
        const makeTags = {};
        tags.forEach((tag) => {
            makeTags[tag.id] = true;
        });
        return {
            id,
            slideId,
            tags: makeTags,
        };
    }, [id, slideId, tags]);
    return (_jsxs("div", Object.assign({ className: 'content_tag_box' }, { children: [_jsx("ul", Object.assign({ className: 'content_tags' }, { children: linkTags.map((linkTag) => (_jsx("li", Object.assign({ className: 'content_tag' }, { children: _jsx(Link, Object.assign({ className: 'content_tag_link', to: linkTag.link }, { children: `#${linkTag.name}` })) }), linkTag.id))) })), canUpdateTag && (_jsxs("button", Object.assign({ className: 'content_tag_add_button', onClick: changeEditModeTrue, type: 'button' }, { children: [_jsx("i", { className: 'css_plus_icon' }), _jsx("span", Object.assign({ className: 'content_tag_add_button_text' }, { children: "\u30BF\u30B0\u306E\u8FFD\u52A0\u30FB\u7DE8\u96C6" }))] }))), _jsx(ContentTagForm, { categoryTags: categoryTags, hideForm: changeEditModeFalse, imageTags: imageTags, initialValues: initialValues, isShow: editMode, onSubmit: onSubmit })] })));
};
ContentTags.propTypes = {
    canUpdateTag: propBool().isRequired,
    categoryTags: propArrayShape().isRequired,
    changeFalseKeyControl: propFunc().isRequired,
    changeTrueKeyControl: propFunc().isRequired,
    id: propId().isRequired,
    imageTags: propArrayShape().isRequired,
    onSubmit: propFunc().isRequired,
    slideId: propStr().isRequired,
    tags: propArrayShape().isRequired,
};
export default ContentTags;
